import Swiper from 'swiper/bundle'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default class Testimonials {
  constructor(el) {
    this.el = el
    this.swiper = null
    this.pochette = this.el.querySelector('.testimonials--pochette')
    this.stack = this.el.querySelector('.testimonials--stack')
    this.init()
  }

  init() {
    this.initSwiper()
    this.initReveal()
    this.initTease()
  }

  initSwiper() {
    const swiperEl = this.el.querySelector('.swiper')
    if (!swiperEl) return

    this.swiper = new Swiper(swiperEl, {
      effect: 'cards',
      grabCursor: true,
      // rewind plutôt que loop : avec seulement 2-3 slides, les clones du loop
      // font "sauter" les cartes de l'effet cards (repositionnement visible)
      rewind: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      cardsEffect: {
        perSlideRotate: 3,
        perSlideOffset: 8,
        slideShadows: false,
      },
    })
  }

  // À l'entrée du bloc dans le viewport, la carte sort de la pochette puis revient
  // (keyframe finie : une fois jouée, le hover CSS reprend la main)
  initReveal() {
    if (!this.pochette) return

    ScrollTrigger.create({
      trigger: this.el,
      start: 'top 70%',
      once: true,
      onEnter: () => this.pochette.classList.add('is-revealed'),
    })
  }

  // Survoler la pochette fait frémir la carte du dessus de la pile
  initTease() {
    if (!this.pochette || !this.stack) return

    this.pochette.addEventListener('mouseenter', () => this.stack.classList.add('is-teased'))
    this.pochette.addEventListener('mouseleave', () => this.stack.classList.remove('is-teased'))
  }
}
